import { render, staticRenderFns } from "./OnboardingTooltip.vue?vue&type=template&id=2fe5734f&"
import script from "./OnboardingTooltip.vue?vue&type=script&lang=js&"
export * from "./OnboardingTooltip.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports